module.exports = __webpack_public_path__ + "media/images/icons/flags/BH-1f52959f1953f1fc4ed82a9302bfd2e0.svg";